export const HELP_QUESTIONS_CRYPTO = [
  {
    title: "راهنمای برداشت ارزهای دیجیتال ( عملیات Withdraw )",
    answer: `
    ابتدا از منوی <span class="n-weight-600">Wallet</span> وارد
    <span class="blue-text"> Spot Wallet </span> خود شده، و بر روی
    دکمه
    <span class="blue-text"> Withdraw </span> کلیک کنید.
    <br /> در این صفحه، تب <span class="blue-text">
      
      Crypto
    </span>
    به صورت پیش فرض انتخاب شده است.
    <br /> جهت واریز ارز دیجیتال،
    <span class="blue-text"> Coin </span> خود را از قسمت
    <span class="blue-text"> Select Coin </span>
    انتخاب نمایید.
    <br />
    <br /> در قسمت <span class="blue-text">
      
      Withdraw to
    </span>
    گزینه <span class="blue-text">Type</span>، شما دو یا سه انتخاب
    به شرح ذیل خواهید داشت:
    <br />
    <br />
    <span class="blue-text n-weight-500"> • SanaCash:</span> با
    انتخاب این گزینه در اصل شما از ساناکش درخواست انتقال ارز داده اید
    که معمولا در زمان کاری شرکت این انتقال برای شما انجام خواهد شد.
    <br />
    <br /> <span class="blue-text n-weight-500">
      
      • Core:
    </span>
    این گزینه برای ارزهای <span class="blue-text">BTC</span>،
    <span class="blue-text">ETH</span>،
    <span class="blue-text">USDT</span> و
    <span class="blue-text">TRX</span> قابل انتخاب است. انتخاب این
    گزینه به معنی آن است که شما از شبکه بلاکچین درخواست انتقال داده
    اید که در 24 ساعت شبانه روز انجام خواهد شد.
    <br />
    <br /> <span class="blue-text n-weight-500">
      • Internal:
    </span>
    این گزینه برای انتقال داخلی ارزهای دیجیتال بدون کارمزد بین کاربران
    <span class="blue-text">SanaCash</span> می باشد.
    <br />
    <br /> برخی از ارزها مانند <span class="blue-text">
      USDT
    </span>
    بر روی شبکه<span class="blue-text"> Network </span>های مختلف
    هستند. درصورتی که ارز انتخابی شما بر روی شبکه های مختلف باشد گزینه
    <span class="blue-text"> Network </span> اضافه شده و شما می
    توانید شبکه مورد نظر خود را انتخاب نمایید.
    <br /> در قسمت آخر شما باید آدرس مقصد و مقدار ارز برداشتی را وارد
    نموده و بر روی دکمه <span class="blue-text">
      Withdraw
    </span>
    کلیک نمایید.
    <br /> <span class="red-text n-weight-600">هشدار:</span> لطفا بطور کامل و چندین
    بار، مقدار ارز درخواستی، آدرس مقصد و تگ یا ممو (در صورت داشتن
    <span class="blue-text">Tag/Memo</span>) را با دقت چک و بررسی
    کنید. <br />
    توجه داشته باشید در صورت وارد کردن اشتباه هر یک از موارد ذکر شده ،
    شما ارز خود را از دست خواهید داد و تراکنش ها در بلاکچین غیر قابل
    برگشت می باشند. <br />
    ساناکش هیچگونه مسئولیتی در قبال اشتباه شما نخواهد داشت.
    <br /> در صورت تایید همه موارد، بر روی دکمه
    <span class="blue-text">Continue</span> کلیک کنید.
    <br /> و در آخر صفحه امنیت برای شما باز شده که در صورت تایید
    امنیت، ارز درخواستی شما برای برداشت تایید خواهد شد.
  `,
  },

  {
    title: "شناسه تراکنش (TxID ) چیست؟",
    answer: `
    شناسه تراکنش <span class="blue-text"> TxID </span>یا هر تراکنش
    یک رشته منحصر به فرد از کاراکترها است که به هر معامله تأیید شده و
    به بلاکچین اضافه می شود. <br />
    به عبارت دیگر، <span class="blue-text">TxID</span> یک شماره
    شناسایی است که هر معامله را در بلاکچین برچسب گذاری می کند.
    <br /> با استفاده از <span class="blue-text">TxID</span> می
    توانید سابقه واریز و برداشت خود را جستجو کنید.
  `,
  },
  {
    title: "چگونه TxID خود را پیدا کنم؟",
    answer: `
    ابتدا وارد حساب ساناکش خود شده، سپس وارد اسپات ولت شوید روی
    <span class="blue-text"> Withdraw </span>
    کلیک کنید، در قسمت پایین صفحه اطلاعات آخرین تراکنش ها که شامل
    <span class="blue-text"> TXID </span>
    است قابل مشاهده می باشد.
    <br /> علاوه بر این شما می توانید در اسپات ولت خود بر روی
    <span class="blue-text">History</span> کلیک نموده و اطلاعات
    سوابق تراکنش ها شامل <span class="blue-text"> TXID </span> را
    در این صفحه مشاهده کنید.
  `,
  },
  {
    title:
      "تفاوت انواع Type برداشت ، در مورد گزینه های sanacash، core، Internal",
    answer: `
    <span class="blue-text n-weight-500"> • type sanacash: </span>
    وقتی شما گزینه ساناکش را انتخاب می کنید، شما در اصل به مجموعه
    ساناکش بابت برداشت ارز مورد نظر درخواست میدهید.
    <br />
    <br />
    <span class="blue-text n-weight-500"> • type core:</span>
    منظور از <span class="blue-text">core</span>، شبکه مرکزی
    بلاکچین آن ارز می باشد که ساناکش در حال حاضر ارزهای اصلی : بیت
    کوین <span class="blue-text"> BTC</span>، اتریوم
    <span class="blue-text"> ETH</span>، ترون
    <span class="blue-text"> TRX</span> و تتر
    <span class="blue-text"> USDT</span> بر روی شبکه های
    <span class="blue-text"> TRC20 </span> و
    <span class="blue-text"> ERC20 </span> را در این قسمت ارائه
    میدهد و در 24 ساعت شبانه روز فعال می باشد.
    <br /><br />
    <span class="blue-text n-weight-500">
      
      • type internal:
    </span>
    شبکه داخلی بین کاربران ساناکش می باشد، در این قسمت شما می توانید
    بدون پرداخت کارمزد، ارز مورد نظر خود را به سایر کاربران انتقال
    دهید .
  `,
  },
  {
    title: "شبکه (network) چیست ؟",
    answer: `
    بعضی از ارزها بصورت توکن بر روی شبکه های اتریوم یا ترون و ...
    انتقال پیدا می کنند در حقیقت توکن ها پیمان هوشمندانه ای هستند که
    از بلاکچین ارزهای اصلی مثل اتریوم استفاده می کنند.
    <br /> بعنوان مثال تتر <span class="blue-text">USDT</span> یک
    ارز استیبل کوین می باشد که هم بر روی شبکه اتریوم با استاندارد
    <span class="blue-text">ERC20</span> ارائه می گردد و هم بر روی
    شبکه ترون با استاندارد <span class="blue-text">TRC20</span>.
 `,
  },
];

export const HELP_QUESTIONS_FIAT = [
  {
    title: "راهنمای برداشت Withdraw FIAT (TOMAN)",
    answer: `
    برای برداشت تومان از قسمت
    <span class="blue-text"> Spot Wallet </span> گزینه
    <span class="blue-text"> Withdraw </span> را انتخاب کرده و در
    بالای صفحه بر روی گزینه <span class="blue-text"> FIAT </span>
    کلیک کنید.
    <br /> در قسمت <span class="blue-text">
      
      Type
    </span> گزینه <span class="blue-text"> SanaCash </span> را
    انتخاب کنید.
    <br /> مقدار مبلغ درخواستی را در قسمت
    <span class="blue-text"> Withdraw amount </span> وارد کنید.
    <br /> در قسمت <span class="blue-text"> Proposal </span>
    درخواست واریز به حسابهای شخصی خود را وارد کنید و بر روی دکمه
    <span class="blue-text">Withdraw</span> کلیک کنید.
   `,
  },
  {
    title: "مدت زمان واریز TOMAN به حساب بانکی شما",
    answer: `
    به محض دریافت درخواست شما
    <span class="blue-text">SanaCash</span> درخواست شما را بررسی
    کرده و در سریع ترین زمان مبلغ درخواستی را به حساب اعلامی واریز
    خواهد کرد و شماره سند واریزی برای شما ارسال خواهد شد.
    <br /> مبالغ درخواستی <span class="blue-text">TOMAN</span> با
    توجه به محدودیت های بانکی و ساعات کاری بانکها 24 تا 48 ساعت بعد از
    درخواست به حساب بانکی شما واریز شود.
  `,
  },
  {
    title: "انتقال وجه به حساب کاربران داخل سایت",
    answer: `در Spot Wallet  بر روی گزینه Withdraw  کلیک کنید، در بالای صفحه گزینه FIAT  را انتخاب کنید، در قسمت  Withdraw to تایپ (Type)  Internal  را انتخاب کرده و سپس Address id   گیرنده مبلغ را وارد کنید و در قسمت Withdraw amount  مقدار مبلغ ارسالی را وارد کنید و بر روی دکمه Withdraw کلیک کنید . مبلغ ارسالی بصورت آنی و بدون هیچ هزینه ای ارسال خواهد شد. `,
  },
  {
    title:
      "بعد از 48 ساعت از درخواست مبلغ تومان ، هنوز پولی به حساب من واریز نشده؟",
    answer:
      "ممکن است درخواست شما در روز غیرکاری بانکها انجام شده باشد که در این صورت شما باید 24 ساعت بعد از اولین روز کاری بانکها، پیگیر عدم واریز از پشتیبانی ما شوید. ",
  },
];
